import SendFilled16 from '@carbon/icons-react/es/send--filled/16';
import { Col, Row } from 'antd';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { ProjectConversationId, ProjectId, User } from 'api/models';
import { Button } from 'components/atoms/button';
import { useMultiUserSelectValue } from 'hooks/use-invite-user';
import { useAddMembersProjectConversationsMutation } from 'queries/project-wide-conversation';
import { SelectUserDropdown } from '../../select-user-dropdown';

interface Props {
  options: User[];
  projectId: ProjectId;
  conversationId: ProjectConversationId;
}

export const UserSelect: FC<Props> = ({
  options,
  conversationId,
  projectId,
}) => {
  const [selectedUsers, setSelectedUsers] = React.useState<User[]>([]);
  const {
    mutate: addMembersToConversationMuatate,
    isLoading: isMembersAdding,
  } = useAddMembersProjectConversationsMutation(projectId);
  const intl = useIntl();

  const confirm = useMultiUserSelectValue(projectId);

  const handleInvite = async () => {
    if (!isEmpty(selectedUsers)) {
      const finalMembers =
        (await confirm(selectedUsers.map((user) => user.userId))) || [];

      await addMembersToConversationMuatate(
        {
          users: selectedUsers.filter((user) =>
            finalMembers.includes(user.userId),
          ),
          conversationId,
        },
        {
          onSuccess: () => {
            setSelectedUsers([]);
          },
        },
      );
    }
  };
  const handleOnChange = (value: User[]) => {
    setSelectedUsers(value || []);
  };

  return (
    <Row>
      <Col flex="auto">
        <SelectUserDropdown
          placeholder={intl.formatMessage({
            id: 'projects.conversations.form.channel.members_search',
          })}
          options={options}
          isDisabled={isMembersAdding}
          isLoading={isMembersAdding}
          projectId={projectId}
          selectedUsers={selectedUsers}
          onChange={handleOnChange}
        />
      </Col>
      <Col flex="none">
        <Button
          type="primary"
          icon={<SendFilled16 />}
          iconPlacement="right"
          onClick={handleInvite}
          loading={isMembersAdding}
          disabled={isEmpty(selectedUsers)}
        >
          <FormattedMessage id="projects.conversations.members.add" />
        </Button>
      </Col>
    </Row>
  );
};
